import React, { FC } from 'react';
import { Col, Flex, Box, Divider } from '@edreamsodigeo/prisma-design-system';
import LegList from '../../../LegList';
import { usePrime } from 'clientState/providers/PrimeProvider';
import PersuasiveTags from '../../../PersuasiveTags/PersuasiveTags';
import TicketsLeftRibbon from '../../../TicketsLefRibbon';
import { shallDisplayTicketsLeft } from '../../../TicketsLefRibbon/TicketsLeftRibbon';
import { LayoutProps } from '../../../types';
import PriceColumnStandard from './PriceColumnStandard';

const ThreeColumnsItineraryLayout: FC<LayoutProps> = ({
  itinerary,
  isSem,
  hasRetailingTechniques = true,
  PriceDescription,
  isAlternativeItinerary,
  isAlternativeTopSection,
  hasAlternativeItineraryDecorator,
  isAlternativeItineraryOnModal,
  isSelectedItinerary,
  isUnavailableItinerary,
}) => {
  const { legs, ticketsLeft, id } = itinerary;
  const { isUK, isPrimeTotalPriceOnCard, isPrimeUser, isPrimeSite } =
    usePrime() || {};
  const withUKStyle =
    isUK && !isPrimeUser && isPrimeSite && !hasAlternativeItineraryDecorator;
  const extraPaddingTop =
    itinerary.highlightedType === 'recommended' ? '1x_small' : null;

  return (
    <Flex
      flexDirection="row"
      position="relative"
      sx={{
        paddingTop: extraPaddingTop,
        ...(isAlternativeTopSection && {
          borderBottom: withUKStyle || isPrimeTotalPriceOnCard ? 'none' : null,
          borderRadius:
            !withUKStyle && !isPrimeTotalPriceOnCard ? 'regular' : null,
          borderTopRightRadius: 'regular',
          borderTopLeftRadius: 'regular',
          margin: !withUKStyle ? '-16px' : null,
        }),
        ...(isAlternativeItineraryOnModal && {
          maxHeight: isSelectedItinerary ? '168px' : '136px',
          borderRadius: 'regular',
          borderBottom: withUKStyle && '1px solid #CBCBCB',
          backgroundColor: isSelectedItinerary ? 'neutral.20' : 'neutral.0',
        }),
      }}
    >
      <Flex
        flexDirection="column"
        justifyContent="center"
        justifyItems="center"
        flexGrow="2"
        sx={{
          ...((withUKStyle || isAlternativeTopSection) && {
            py: 'base',
            pl: 'base',
          }),
        }}
      >
        {!isAlternativeItineraryOnModal && (
          <PersuasiveTags
            hasRetailingTechniques={hasRetailingTechniques}
            itineraryId={id}
            isUnavailableItinerary={isUnavailableItinerary}
          />
        )}
        <Flex flexGrow="1" alignItems="center">
          <LegList
            legs={legs}
            isSem={isSem}
            isAlternativeItinerary={isAlternativeItinerary}
          />
        </Flex>
      </Flex>

      <Col>
        <Box height="100%" ml="base" mr="1x_small">
          <Divider orientation="vertical" type="dashed" color="neutral.40" />
        </Box>
      </Col>

      <Flex
        width="72px"
        maxWidth="72px"
        minWidth="72px"
        sx={{
          ...((withUKStyle || isAlternativeTopSection) && {
            py: 'base',
            pr: 'base',
            width: '85px',
            maxWidth: '85px',
            minWidth: '85px',
          }),
        }}
        mt={
          hasRetailingTechniques && shallDisplayTicketsLeft(ticketsLeft)
            ? '1x_big'
            : null
        }
      >
        <PriceColumnStandard
          itinerary={itinerary}
          PriceDescription={PriceDescription}
          hasRetailingTechniques={hasRetailingTechniques}
          isAlternativeItinerary={isAlternativeItinerary}
          isAlternativeItineraryOnModal={isAlternativeItineraryOnModal}
        />
      </Flex>

      {hasRetailingTechniques && (
        <TicketsLeftRibbon
          ticketsNumber={ticketsLeft}
          withUKStyle={withUKStyle}
        />
      )}
    </Flex>
  );
};

export default ThreeColumnsItineraryLayout;
